import Image from "next/image";
import Link from "next/link";
import { storyblokEditable, StoryblokComponent } from "@storyblok/react/rsc";

import { Button } from "@/components/ui/button";
import { Headline } from "@/components/typography/Headline";
import { CopyText } from "@/components/typography/CopyText";
import type { TextSectionStoryblok } from "@/component-types-sb";
import { getUrlFromLinkObject } from "@/lib/storyblok/utils";

type TextSectionProps = {
  blok: TextSectionStoryblok;
};

const TextSection = ({ blok }: TextSectionProps) => {
  const buttonHref =
    getUrlFromLinkObject(blok.button_link) || undefined;

  return (
    <section className="p-4 md:p-14 text-black-100" {...storyblokEditable(blok)}>
      <article className="max-w-2xl">
        <Headline as="h3" size="tall" className="mb-8">
          {blok.headline}
        </Headline>
        <CopyText className="mb-4">{blok.text}</CopyText>

        {blok.image?.filename && (
          <Image
            src={blok.image.filename}
            alt={blok.image.alt || ""}
            className="w-full h-auto max-h-64 rounded-3xl object-cover object-center my-16"
            width={800}
            height={600}
          />
        )}

        {blok.body?.map((nestedBlok: any) => (
          <StoryblokComponent key={nestedBlok._uid} blok={nestedBlok} />
        ))}

        {blok.button_label && buttonHref && (
          <Button variant="black" className="w-full mt-6" asChild>
            <Link href={buttonHref}>{blok.button_label}</Link>
          </Button>
        )}
      </article>
    </section>
  );
};

export default TextSection;
